<button
    class="cerrix-btn"
    [class]="buttonClass"
    [class.success]="showResultText"
    [disabled]="disabled"
>
    @if (!waitingOnResult && !showResultText) {
        <span class="button-text" [class.has-icon]="!!icon">
            @if (icon && iconPosition !== "right") {
                <mat-icon [svgIcon]="icon" />
            }
            @if (text !== undefined) {
                {{ text }}
            } @else {
                <ng-content></ng-content>
                <ng-content select="[button-text]"></ng-content>
            }
            @if (icon && iconPosition !== "left") {
                <mat-icon [svgIcon]="icon" />
            }
        </span>
    }

    <div class="button-loader" [class.d-none]="!waitingOnResult"></div>

    @if (showResultText) {
        <span class="button-text">
            @if (resultText !== undefined) {
                {{ resultText }}
            } @else {
                <ng-content select="[result-text]"></ng-content>
            }
        </span>
    }
</button>
